import Opportunities from '@/views/Opportunities.vue'
import Files from '@/views/Files.vue'
import NewOpportunity from '@/views/NewOpportunity.vue'
import EditOpportunity from '@/views/EditOpportunity.vue'
import OpportunityDetails from '@/components/opportunity-details/OpportunityDetails.vue'
import OpportunitySelect from '@/components/opportunity-select/OpportunitySelect.vue'
import OpportunityEdit from '@/components/opportunity-edit/OpportunityEdit.vue'
import NotFound from '@/views/NotFound.vue'

import store from '@/store'
import WizardConfig from '@/components/_shared/wizard/config.js'
import config from '@/config'

const underMaintenance = false

const routes = [
  {
    path: (underMaintenance) ? '/login' : '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
  },
  {
    path: (underMaintenance) ? '/' : '/under-maintenance',
    name: 'under-maintenance',
    component: () => import(/* webpackChunkName: "maintenance" */ '@/views/MaintenancePage.vue')
  },
  {
    path: '/password-recovery',
    name: 'password-recovery',
    component: () => import(/* webpackChunkName: "password-recovery" */ '@/views/PasswordRecovery.vue')
  },
  {
    path: '/password_reset',
    name: 'password-reset',
    component: () => import(/* webpackChunkName: "password-reset" */ '@/views/PasswordReset.vue'),
    beforeEnter (to, from, next) {
      if (!to.query.token) {
        window.location.href = '/'
      }
      return next()
    }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
    meta: { requiresAuth: true },
    beforeEnter (to, from, next) {
      store
        .dispatch('opportunity/getNewOpportunity')
        .then((response) => {
          next()
        })
        .catch(error => {
          if (error.response && error.response.status > 400) { // 401 || 403
            // store.dispatch('auth/removeToken')
          }
        })
      next()
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "profile" */ '@/views/Profile.vue'),
    meta: { requiresAuth: true },
    props: true,
    beforeEnter (to, from, next) {
      store
        .dispatch('profile/fetchProfile')
        .then(profile => {
          to.params.profile = profile
          next()
        })
        .catch(error => {
          if (error.response && error.response.status > 400) { // 401 || 403
            // store.dispatch('auth/removeToken')
          }
        })
    }
  },
  {
    path: '/opportunity/:privateId',
    component: NewOpportunity,
    meta: { requiresAuth: true },
    props: true,
    beforeEnter (to, from, next) {
      const stepSelected = WizardConfig.stepValues.filter(s => s.url === to.name).shift()
      to.params.step = stepSelected.number

      store
        .dispatch('opportunity/getNewOpportunity')
        .then((response) => {
          next()
        })
        .catch(error => {
          if (error.response && error.response.status > 400) { // 401 || 403
            // store.dispatch('auth/removeToken')
          }
        })
      next()
    },
    children: [
      {
        path: 'details',
        name: 'opportunity-details',
        components: {
          default: NewOpportunity,
          content: OpportunityDetails
        },
        props: true
      },
      {
        path: 'select',
        name: 'opportunity-select',
        components: {
          default: NewOpportunity,
          content: OpportunitySelect
        },
        props: true
      }
    ]
  },
  {
    path: '/opportunity/:privateId',
    component: EditOpportunity,
    meta: { requiresAuth: true },
    props: true,
    beforeEnter (to, from, next) {
      const privateId = to.params.privateId

      store.commit('opportunity/SET_OPPORTUNITY_DATA', null)

      store
        .dispatch('location/getCountries')
        .then((response) => {
          next()
        })
      store
        .dispatch('opportunity/getNewOpportunity')
        .then((response) => {
          next()
        })
        .catch(error => {
          if (error.response && error.response.status > 400) { // 401 || 403
            // store.dispatch('auth/removeToken')
          }
        })
      store
        .dispatch('opportunity/getOpportunity', privateId)
        .then((response) => {
          to.params.data = response
          next()
        })
        .catch(error => {
          console.log(error)
          if (error.response && error.response.status >= 400) {
            if (!error.response.data.status) {
              window.location.href = '/404'
            }
          }
          if (error.response && error.response.status > 400) { // 401 || 403
            // store.dispatch('auth/removeToken')
          }
        })
    },
    children: [
      {
        path: 'edit',
        name: 'opportunity-edit',
        components: {
          default: EditOpportunity,
          content: OpportunityEdit
        },
        props: true
      }
    ]
  },
  {
    path: '/opportunities',
    name: 'quotes',
    component: Opportunities,
    meta: { requiresAuth: true },
    props: true,
    beforeEnter (to, from, next) {
      const TYPE = 5
      const payload = {
        query: '',
        type: TYPE,
        limit: config.opportunityList.pagination.byPage,
        offset: 0
      }
      store
        .dispatch('opportunity/listOpportunities', payload)
        .then(response => {
          to.params.meta = {
            title: 'Opportunities',
            type: 'quote',
            typeId: TYPE
          }
          next()
        })
        .catch(error => {
          if (error.response && error.response.status > 400) { // 401 || 403
            // store.dispatch('auth/removeToken')
          }
        })
    }
  },
  {
    path: '/drafts',
    name: 'drafts',
    component: Opportunities,
    meta: { requiresAuth: true },
    props: true,
    beforeEnter (to, from, next) {
      const TYPE = 24
      const payload = {
        query: '',
        type: TYPE,
        limit: config.opportunityList.pagination.byPage,
        offset: 0
      }
      store
        .dispatch('opportunity/listOpportunities', payload)
        .then(response => {
          to.params.meta = {
            title: 'Drafts',
            type: 'draft',
            typeId: TYPE
          }
          next()
        })
        .catch(error => {
          if (error.response && error.response.status > 400) { // 401 || 403
            // store.dispatch('auth/removeToken')
          }
        })
    }
  },
  {
    path: '/files',
    name: 'files',
    component: Files,
    meta: { requiresAuth: true }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/404',
    name: '404',
    component: NotFound,
    meta: { requiresAuth: true }
  },
  {
    path: '/xxx',
    redirect: { name: 'quotes' }
  },
  {
    path: '*',
    redirect: { name: '404' }
  }
]

export default routes
